<template>
  <div>
    <div class="bd-header bd-header_kolesa">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title">
        <img class="bd-header__logo" src="/pages/kolesa/img/logo.svg" alt="">
        <div class="bd-header__search-block">
          <div class="bd-header__search-block-entrance">Вход</div>
          <img class="bd-header__search-block-img" src="/pages/kolesa/img/search.svg">
        </div>
      </div>
    </div>
    <div class="bd-feed bd-feed_kolesa">
      <div class="one-block">
         <ul class="one-block__list">
            <li>Главная</li>
            <li>Статьи</li>
            <li>Точка опоры: угадаешь ли ты автомобиль по его креслу</li>
         </ul>
         <div class="one-block__author">
            <img class="one-block__author-img" src="/pages/kolesa/img/author.png">
            <div class="one-block__author-text">Автор: <span class="one-block__author-text-underline">Влад Самарин</span>
            </div>
         </div>
         <h1 class="one-block__h1">Точка опоры: угадаешь ли ты автомобиль по его креслу</h1>
         <div class="likes-comments-block">
            <span class="likes-comments-block__item">12.03.2022</span>
            <span class="likes-comments-block__item"> &#128065; 1316 </span>
            <span class="likes-comments-block__item"> &#128172; 0 </span>
            <span class="likes-comments-block__item"> &#9825; 9 </span>
         </div>
         <img class="one-block__img-1" src="/pages/kolesa/img/1.jpg">
         <div class="one-block__item">В интерьере автомобиля существует немало деталей, по которым его можно идентифицировать. К примеру, мы предлагали вам сделать это по <span class="red-text">рулевому колесу, рычагу переключения передач, климат-контролю, аудиосистеме</span> и даже <span class="red-text">часам</span>. Но какой еще элемент, помимо руля и педалей, входит в число первично важных для водителя? Сиденье! И хотя для сидений прежде всего значимы эргономика и удобство, их дизайн всегда был способом разнообразить интерьер. Предлагаем вам угадать автомобили из той эпохи, когда машины и внутри, и снаружи отличались друг от друга куда заметнее, чем в наше время.</div>
        <div class="bd-feed__buzzcode">
          <buzzCode @ready="ready" :id="id"></buzzCode>
        </div>
         <img src="/pages/kolesa/img/9.jpg" alt="" class="one-block__line">
         <div class="one-block__test">
            <img class="one-block__test-img" src="/pages/kolesa/img/2.jpg">
            <div class="one-block__test-question">Первый автомобиль родом из 70-х, так что здесь может пригодиться звонок дедушке, особенно если он родом из ФРГ.</div>
            <div class="test-answers">
               <div class="test-answers__form">
                  <input id="answers-1" type="radio" name="radio" value="1">
                  <label for="answers-1">Opel Kadett C</label>
               </div>
               <div class="test-answers__form">
                  <input id="answers-2" type="radio" name="radio" value="2">
                  <label for="answers-2">Ford Capri</label>
               </div>
               <div class="test-answers__form">
                  <input id="answers-3" type="radio" name="radio" value="3">
                  <label for="answers-3">BMW Е21</label>
               </div>
               <div class="test-answers__form">
                  <input id="answers-4" type="radio" name="radio" value="4">
                  <label for="answers-4">Audi 100 Coupe C1</label>
               </div>
            </div>
         </div>
      </div>
      <div class="second-block">
         <h2 class="second-block__h2">Новые статьи</h2>

         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/3.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">Старое лучше нового и спортивный дизель: стоит ли покупать BMW X3 I за миллион рублей.</div>
           <div class="second-block__desc">Кроссовер сегодня хочет каждый второй, а уж если кроссовер премиальный, то и подавно. Но свежие машины изрядно дороги: почти новый  Lexus NX стоит 3 миллиона, пятилетний Mercedes-Benz GLK</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 2092</span>
              <span class="likes-comments-block__item"> &#128172; 0</span>
              <span class="likes-comments-block__item"> &#9825; 1</span>
           </div>
         </div>

         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/4.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">Дикий бизнес: сколько реально сейчас стоят машины в автосалонах</div>
           <div class="second-block__desc">Даже если вы готовы в сегодняшних реалиях потратиться на новую машину, не факт, что покупка состоится. Некоторые дилеры вообще остановили продажи, хотя автомобили у них есть.</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 39</span>
              <span class="likes-comments-block__item"> &#128172; 0</span>
              <span class="likes-comments-block__item"> &#9825; 0
              </span>
           </div>
          </div>


         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/5.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">Дороже новых: какие машины меньше теряют в цене</div>
           <div class="second-block__desc">Многие автомобилисты, выбирая новую машину, уже прикидывают, как будут ее перепродавать. Понятно, что последние месяцы рынок непредсказуем – сказывается и рост цен, и дефицит, но все равно в...</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 3078 </span>
              <span class="likes-comments-block__item"> &#128172; 4 </span>
              <span class="likes-comments-block__item"> &#9825; 5 </span>
           </div>
          </div>
         <h2>Популярные тест-драйвы</h2>

         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/6.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">15 литров, 600 сил и полный комфорт: тест-драйв Урал-ТМ Барс за 20 миллионов</div>
           <div class="second-block__desc">Я не очень люблю серийные машины, которые прошли какую-то модернизацию. От них почти всегда веет какой-то небрежностью, кустарщиной, невниманием к деталям, а в самых запущенных случаях – син...</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 20850 </span>
              <span class="likes-comments-block__item"> &#128172; 0 </span>
              <span class="likes-comments-block__item"> &#9825; 22 </span>
           </div>
          </div>


         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/7.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">Полный сток, зелёный салон и 400 тысяч пробега: опыт владения Mercedes S124</div>
           <div class="second-block__desc">Казалось, еще недавно 124-е Мерседесы, любимые народом, вовсю покупали на вторичке для езды как уже непрестижную, но сверхнадежную и неубиваемую машину, однако это время безвозвратно прошло…...</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 17428 </span>
              <span class="likes-comments-block__item"> &#128172; 21 </span>
              <span class="likes-comments-block__item"> &#9825; 25 </span>
           </div>
          </div>

         <div class="second-block__item">
           <img class="second-block__img" src="/pages/kolesa/img/8.jpg">
           <div class="second-block__category">Статьи</div>
           <div class="second-block__title">Тест-драйв Genesis GV70: приборка с 3D-эффектом, салон круче, чем у BMW, и экономия в миллион</div>
           <div class="second-block__desc">Младший кроссовер корейского премиум-бренда записал в свои конкуренты Audi Q5, BMW X3 и Mercedes-Benz GLC. Способен ли корейский выскочка отбить покупателей у признанных авторитетов?</div>
           <div class="likes-comments-block likes-comments-block_grey">
              <span class="likes-comments-block__item"> &#128065; 15941 </span>
              <span class="likes-comments-block__item"> &#128172; 1 </span>
              <span class="likes-comments-block__item"> &#9825; 6 </span>
           </div>
          </div>
      </div>
      <div class="footer">
        <img class="footer__logo" src="/pages/kolesa/img/logo-white.svg"/>
        <div class="social-links">
          <img src="/pages/kolesa/img/twitter.svg" class="social-links__icon">
          <img src="/pages/kolesa/img/inst.svg" class="social-links__icon">
          <img src="/pages/kolesa/img/vkont.svg" class="social-links__icon">
          <img src="/pages/kolesa/img/youtube.svg" class="social-links__icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';


export default {
  name: 'kolesa',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &_kolesa
      height 52px !important
      border-bottom 1px solid rgba(170,170,170,0.5)
      background-color #fff
      box-shadow 0 3px 6px rgba(0, 0, 0, 0.15)
    &__menu
      width 30px
      height 20px
      margin 15px
      -webkit-tap-highlight-color transparent
      outline none
      svg
        width 100%
        height 100%
        display block
        fill #c50005
    &__title
      display flex
      align-items center
      justify-content space-between
      width 100%
    &__logo
      width auto
      height 29px
      padding-bottom 3px
    &__search-block
      display flex
      align-items center
      justify-content space-between
      &-img
        width 23px
        height auto
        padding 0 15px
      &-entrance
        color #26272a
        font-size 18px
        line-height 24px
        padding 0 15px
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
    text-align left
    font-family "PT Sans", sans-serif
    &__buzzcode
      padding 20px 0

img
  display block
  max-width 100%
  height auto

.one-block
  position relative
  background #fff
  padding 10px 20px
  box-sizing border-box
  overflow-x hidden
  &__img-1
    margin 10px 0
  &__item
    fontSize(20, 26)
    font-weight 700
    color #575252
    margin 17px 0
    padding 0
  &__test
    border-radius 10px
    margin 20px 0
    border solid 1px #e8e8e8
    &-img
      border-radius 10px
    &-question
      fontSize(22, 30)
      font-weight 600
      padding 20px
  &__list
    margin-top 20px
    margin-bottom 10px
    padding 8px 15px 8px 0
    li
      display inline
      color #ababab
      fontSize(14, 16)
      &+li:before
        content "/ "
        padding 0 5px
        color #ccc
  &__line
    margin 40px 0 20px
  &__author
    margin-top 0
    margin-bottom 20px
    overflow hidden
    &-img
      width 50px
      height 50px
      object-fit cover
      border-radius 50%
      display inline-block
      margin-right 10px
      vertical-align middle
    &-text
      display inline-block
      fontSize(14, 15)
    &-text-underline
      text-decoration underline
  &__h1
    font-family "PT Serif", serif
    fontSize(24, 28)
    font-weight 700

.test-answers
  padding-bottom 13px
  &__form
    & input[type=radio]
      display none
    & label
      display inline-block
      position relative
      padding-left 25px
      margin-right 0
      line-height 18px
      user-select none
      fontSize(20, 42)
    & label:before
      content ""
      display inline-block
      width 17px
      position absolute
      left 0
      bottom 1px
      margin-right 15px
      border-radius 50%
      width 20px
      min-width 20px
      height 20px
      border solid 1px #e8e8e8
      position relative
    & input[type=radio]:checked+label:before
      background-color #bbbbbb

.red-text
  color #bf2b29

.second-block
  position relative
  margin-top 30px
  background #fff
  padding 20px
  box-sizing border-box
  &__category
    fontSize(14, 16)
    color #8c1c3c
    padding 15px 0 0
  &__h2
    margin 20px 0 35px
    font-weight 500
    fontSize(30, 35)
    color #3e3e41
  &__img
    margin 10px 0
  &__title
    color #3e3e41
    font-weight 700
    padding 15px 0 0
    fontSize(18, 20)
  &__desc
    color #3e3e41
    padding 15px 0 0
    fontSize(14, 18)
    font-weight 400

.likes-comments-block
  &_grey
    padding 25px 0 30px
    color #b2b2b5
  &__item
    display inline-block
    margin-right 10px
    fontSize(12, 14)

.footer
  position relative
  padding 20px
  padding-bottom 40px
  margin-right auto
  margin-left auto
  background-color #6a6a6a
  &__logo
    width 148px
    margin-bottom 30px
    fill #c5c5c5

.social-links
  display flex
  &__icon
    width 39px
    margin 20px
    margin-left 0

.social-contacts
  margin 10px
  margin-left 0
  &__text
    display inline-block
    color white
    font-size 20px
    margin-right 10px
  &__picture
    display inline-block
    vertical-align middle

</style>
